import { IdNameObject } from '@m/types';
import { LicensePlate } from '@m/types/api';

export enum ColumnType {
  CarsParked = 'cars parked',
  CarsToGarage = 'cars to garage',
  CarsToHotel = 'cars to hotel',
}

export enum RequestStatus {
  Requested = 'requested',
  InProgress = 'in progress',
  Complete = 'complete',
  Parked = 'parked',
}

export enum HospitalityStayStatus {
  PickUpRequested = 'Pick Up Requested',
  PickUpInProgress = 'Pick Up In Progress',
  Parked = 'Parked',
  DropOffRequested = 'Drop Off Requested',
  DropOffInProgress = 'Drop Off In Progress',
  DroppedOff = 'Dropped Off',
  Completed = 'Completed',
}

export enum HospitalityStayType {
  Transient = 'Transient',
  Overnight = 'Overnight',
}

export enum DashboardView {
  TODO = 'todo',
  PARKED = 'parked guests',
  TOPARK = 'send to park',
  TOPROP = 'send to property',
}

export enum VisitCardActionButtonType {
  SendToHotel = 'Send to Hotel',
  GuestRecievedVehicle = 'Guest Recieved Vehicle',
}

export type HospitalityStayDetails = {
  active: boolean;
  checkInDate: number | null;
  checkOutDate: number | null;
  driverFirstName: string;
  driverLastName: string;
  guestFirstName: string | null;
  guestLastName: string | null;
  hotelName: string;
  hotelTicketNumber: string;
  id: string;
  intakePartnerId: number;
  isOversizedVehicle: boolean | null;
  roomNumber: string | null;
  siteId: number;
  status: IdNameObject;
  stayType: IdNameObject;
  visitEnd: number | null;
  visitStart: number;
};

export type HospitalityVehicle = {
  id: number;
  licensePlate: LicensePlate;
};

export type HospitalityVehicleEvent = {
  dropOffInProgressAt: number | null;
  dropOffRequestedAt: number | null;
  droppedOffAt: number | null;
  hospitalityStayUuid: string;
  id: string;
  parkedAt: number | null;
  pickUpInProgressAt: number | null;
  pickUpRequestedAt: number | null;
  valetVisitUuid: string | null;
};

export type HospitalityStay = {
  hospitalityStay: HospitalityStayDetails;
  vehicle?: HospitalityVehicle;
  vehicleEvent?: HospitalityVehicleEvent;
};

export enum VisitCardVariant {
  SearchResult = 'search result',
}

export type VisitCardProps = {
  details: HospitalityStay;
  variant?: VisitCardVariant;
};

export enum StaySiteType {
  OffSite = 'Off-site',
  OnSite = 'On-site',
}
